export const clearing_and_grubbing = [

    {
        "A": "03-62",
        "B": "Clearing and Grubbing by mechanical means",
        "C": 100,
        "D": 0,
    }
]